import { render } from "./Closable.vue?vue&type=template&id=1a745030"
import script from "./Closable.vue?vue&type=script&lang=js"
export * from "./Closable.vue?vue&type=script&lang=js"
script.render = render

export default script